module.exports = __webpack_public_path__ + "static/media/jenniferrowecircle.31b1d7ce.png";